import 'flickity/dist/flickity.min.css';
const Flickity = require('flickity');
require('flickity-fade');

jQuery(document).ready(function($) {

	if ( $('.testimonials-carousel--wrapper').length > 0 && !window.document.documentMode ) {

		$('.testimonials-carousel--wrapper').each(function() {

			let _this     = $(this).attr('id');
			let _settings = JSON.parse($(this).attr('data-settings'));
			// console.log('#'+_this);
			// console.log(_settings);
			let flkty     = new Flickity( '#'+_this, _settings);

		});

	}

});
